<h3 class="font-brand" translate>AUTH_LOGIN_TITLE</h3>
<div class="form-actions">
  <img src="/assets/images/loading.svg" alt="Loading...">
  <h4 translate>AUTH_LOGIN_AUTO_TITLE</h4>
</div>
